import React from "react";
import FeatureBlock from "./elements/FeatureBlock";
import { getImage } from "../../helpers/images";

const title = 'Get new sounds effortlessly';

export default class StraightToSoundBlock extends React.PureComponent {
    render() {
        return (
            <div className={'straight-to-sound'}>
                <FeatureBlock
                    title={title}
                    className={'staight-to-sounds-feature'}
                >You can get every Capsule directly:<br/>no website or installer needed. Use the desktop app to download your desired sounds, without ever leaving your DAW.</FeatureBlock>

                <img alt={title} className={'mobile-element'} src={getImage('bg/straight-to-sound-4-2-cut.webp')}/>
            </div>
        );
    }
}
